import smoothScroll from 'smooth-scroll-into-view-if-needed';

angular.module('gym.calendar').directive('editEventSchedule', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/edit_event_schedule.html.slim'),
    scope: {
      gym: '=',
      event: '=',
      classrooms: '=',
      styles: '=',
      eventTypes: '='
    },
    controller: ["$document", "$scope", "$rootScope", "$state", "$window", "$timeout", "$interval", "$q", "$http", "flash", "loadingAnimation", "EmploymentService", "FeatureAvailabilityService", "FeatureFlagsService", "FeatureFlag", "CalendarLastVisitedViewService", "CalendarService", "MasqueradingService", "GTMService", "EventService", "isInteger", "ReactModal", function($document, $scope, $rootScope, $state, $window, $timeout, $interval, $q, $http, flash, loadingAnimation, EmploymentService, FeatureAvailabilityService, FeatureFlagsService, FeatureFlag, CalendarLastVisitedViewService, CalendarService, MasqueradingService, GTMService, EventService, isInteger, ReactModal) {
      var getActiveSection, gym, isScrolledTo, validateEvent;
      gym = $scope.gym;
      $scope.defaultCalendarView = CalendarLastVisitedViewService.get();
      $document.scrollTop(0);
      $scope.permissions = EmploymentService.get().permissions;
      $scope.attendanceFeatureAvailable = FeatureAvailabilityService.isAvailable('attendance');
      $scope.eventCancellationsEnabled = FeatureFlagsService.isEnabled(FeatureFlag.EventCancellations);
      GTMService.trackPage('Event details');
      $scope.isMasquerading = MasqueradingService.isMasquerading();
      $scope.instructorNames = function() {
        return EventService.eventInstructorNames($scope.event);
      };
      $scope.getRecurringBookings = function() {
        var event, params;
        event = $scope.event;
        params = {
          event_schedule_id: event.event_schedule_id
        };
        return EventService.getRecurringBookings(params).then(function(recurringBookings) {
          $scope.recurringBookings = recurringBookings;
          return $scope.otherRecurringBookings = recurringBookings.filter(function(item) {
            var attendee, waitlist;
            attendee = _.find($scope.bookings, function(booking) {
              return item.contact_id === booking.student_id;
            });
            waitlist = _.find(event.waitlist_attendees.collection, function(waitlist) {
              return item.contact_id === waitlist.contact_id;
            });
            return !attendee && !waitlist;
          });
        });
      };
      $scope.getBookings = function() {
        var eventCancellationId, ref;
        if ($scope.event.cancelled) {
          eventCancellationId = (ref = $scope.event.cancellation_details) != null ? ref.event_cancellation_id : void 0;
          return EventService.getCancelledBookings($scope.event.id, eventCancellationId).then(function(bookings) {
            return $scope.bookings = bookings;
          });
        } else {
          return EventService.getBookings($scope.event.id).then(function(bookings) {
            $scope.bookings = bookings;
            return $scope.getRecurringBookings();
          });
        }
      };
      $scope.getBookings();
      $scope.pageParams = {
        activeSection: 'general'
      };
      isScrolledTo = function(selector) {
        var element, middleOfViewport, rect;
        element = angular.element(selector)[0];
        if (element) {
          rect = element.getBoundingClientRect();
          middleOfViewport = window.innerHeight / 2;
          return rect.top <= middleOfViewport && rect.bottom >= middleOfViewport;
        } else {
          return false;
        }
      };
      getActiveSection = _.throttle(function() {
        var activeSection, sections;
        sections = ['log', 'notes', 'activity', 'repeats', 'restrictions', 'recurring_bookings', 'attendees', 'general'];
        activeSection = _.find(sections, function(section) {
          return isScrolledTo(`[data-section='${section}']`);
        }) || 'general';
        return $timeout(function() {
          return $scope.$apply(function() {
            return $scope.pageParams.activeSection = activeSection;
          });
        });
      }, 300);
      window.addEventListener('scroll', getActiveSection);
      $scope.$on('$destroy', function() {
        return window.removeEventListener('scroll', getActiveSection);
      });
      $scope.scrollTo = function(section) {
        var element;
        element = angular.element(`[data-section='${section}']`)[0];
        if (element) {
          $scope.pageParams.activeSection = section;
          $scope.pageParams.ignoreSectionChangeOnScroll = true;
          smoothScroll(element, {
            speed: 700,
            speedAsDuration: false,
            block: 'center',
            inline: 'center'
          });
          return $timeout(function() {
            return $scope.pageParams.ignoreSectionChangeOnScroll = false;
          }, 0);
        }
      };
      $scope.isRepeating = function() {
        return !!$scope.event.repeats || !!$scope.event.repeat_until_date || !!$scope.event.infinite;
      };
      $scope.onEdit = function() {
        var confirmText;
        confirmText = 'Are you sure you want to leave this page? Changes that you made may not be saved.';
        $rootScope.stateChangeConfirmMessage = confirmText;
        return $window.onbeforeunload = function(e) {
          e.returnValue = confirmText;
          return confirmText;
        };
      };
      $scope.removePageLeaveListeners = function() {
        $rootScope.stateChangeConfirmMessage = void 0;
        return $window.onbeforeunload = void 0;
      };
      $scope.cancelEdit = function() {
        return $scope.removePageLeaveListeners();
      };
      $scope.onNotesUpdated = function(notes) {
        return $scope.event.notes = notes;
      };
      $scope.reloadEvent = function() {
        var bookingsPromise, promises;
        bookingsPromise = $scope.event.cancelled ? EventService.getCancelledBookings($scope.event.id) : EventService.getBookings($scope.event.id);
        promises = [$scope.event.get(), bookingsPromise];
        return $q.all(promises).then(function(response) {
          $scope.event = response[0];
          $scope.bookings = response[1];
          if (!$scope.event.cancelled) {
            return $scope.getRecurringBookings();
          }
        });
      };
      $scope.showAllBookingsAvailable = function(booking) {
        var ref;
        return $scope.event.all_events_count > 1 && (((ref = booking.contact_type) != null ? ref.toLowerCase() : void 0) === 'member' || booking.student.type === 'member');
      };
      $scope.showAllBookings = function(booking) {
        return ReactModal.open({
          component: 'BookedEventsInSeriesModal',
          drawer: true,
          props: {
            booking: booking,
            event: $scope.event.plain()
          }
        });
      };
      validateEvent = function(event) {
        var errors;
        errors = {};
        if (event.event_types_join_attributes) {
          _.each(event.event_types_join_attributes, function(limit, index) {
            var error;
            error = '';
            if (limit.participant_limit > event.participant_limit) {
              error = 'Should be less than or equal to event participant limit';
            }
            if (!(limit.participant_limit === null || (isInteger(limit.participant_limit) && limit.participant_limit >= 0))) {
              error = 'Is invalid';
            }
            if (error) {
              return errors[`event_types_join_attributes.participant_limit[${index}]`] = [error];
            }
          });
        }
        if (+event.late_cancellation_fee && event.late_cancellation_fee < 1) {
          errors.late_cancellation_fee = ["must be greater than or equal to 1"];
        }
        return errors;
      };
      $scope.save = function(event) {
        var deferred, errors, temp_bookings_allowed_after_number, temp_bookings_allowed_after_unit, temp_bookings_allowed_before_number, temp_bookings_allowed_before_unit, temp_cancel_before_number, temp_cancel_before_unit;
        deferred = $q.defer();
        errors = validateEvent(event);
        if (!_.isEmpty(errors)) {
          event.errors = errors;
          flash.error = 'Update failed. Please fix the errors below';
          deferred.reject(event);
          return deferred.promise;
        }
        loadingAnimation.show();
        $scope.isLoading = true;
        if (!event.restrict_cancellations) {
          temp_cancel_before_number = event.cancel_before_number;
          temp_cancel_before_unit = event.cancel_before_unit;
          event.cancel_before_number = null;
          event.cancel_before_unit = null;
        }
        if (!event.restrict_bookings_before) {
          temp_bookings_allowed_before_number = event.bookings_allowed_before_number;
          temp_bookings_allowed_before_unit = event.bookings_allowed_before_unit;
          event.bookings_allowed_before_number = null;
          event.bookings_allowed_before_unit = null;
        }
        if (!event.restrict_bookings_after) {
          temp_bookings_allowed_after_number = event.bookings_allowed_after_number;
          temp_bookings_allowed_after_unit = event.bookings_allowed_after_unit;
          event.bookings_allowed_after_number = null;
          event.bookings_allowed_after_unit = null;
        }
        event.save({
          edit_type: event.edit_type,
          edit_scope: event.editScope
        }).then(function(data) {
          $scope.event = angular.extend(event, data);
          $scope.cancelEdit();
          flash.success = 'Updated successfully';
          loadingAnimation.hide();
          $scope.isLoading = false;
          return deferred.resolve($scope.event);
        }, function(response) {
          var defaultError;
          $document.scrollTop(0);
          defaultError = 'Update failed. Please fix the errors below';
          flash.error = response.data.error || response.data.error_message || defaultError;
          event.errors = {};
          if (response.data.event_schedule) {
            event.errors = angular.extend({}, response.data.event_schedule.errors, response.data.event_schedule.update_errors);
          }
          loadingAnimation.hide();
          $scope.isLoading = false;
          if (!event.restrict_cancellations) {
            event.cancel_before_number = temp_cancel_before_number;
            event.cancel_before_unit = temp_cancel_before_unit;
          }
          if (!event.restrict_bookings_before) {
            event.bookings_allowed_before_number = temp_bookings_allowed_before_number;
            event.bookings_allowed_before_unit = temp_bookings_allowed_before_unit;
          }
          if (!event.restrict_bookings_after) {
            event.bookings_allowed_after_number = temp_bookings_allowed_after_number;
            event.bookings_allowed_after_unit = temp_bookings_allowed_after_unit;
          }
          return deferred.reject(event);
        });
        return deferred.promise;
      };
      $scope.delete = function() {
        return CalendarService.deleteEvent($scope, $scope.event, $scope.removePageLeaveListeners);
      };
      $scope.cancelEvent = function() {
        return $state.go('gym.cancelEvent', {
          eventId: $scope.event.id
        });
      };
      return $scope.restoreEvent = function() {
        if (!$scope.permissions.cancel_events) {
          flash.error = 'You do not have permission to restore events';
          return;
        }
        return ReactModal.open({
          component: 'RestoreEventModal',
          props: {
            onRestore: function() {
              var eventId, gymId;
              loadingAnimation.show();
              gymId = $scope.gym.id;
              eventId = $scope.event.id;
              return $http.put(`/gyms/${gymId}/calendar/events/${eventId}/uncancel`).then(function(response) {
                flash.success = 'Event restored';
                $scope.event.cancelled = false;
                $scope.reloadEvent();
                return loadingAnimation.hide();
              }).catch(function(error) {
                var ref;
                flash.error = ((ref = error.data) != null ? ref.error : void 0) || 'Failed to restore event. Please try again.';
                loadingAnimation.hide();
                throw error;
              });
            }
          }
        });
      };
    }]
  };
});
